window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-qa-items:not(.initialized)').forEach(qa => {
    const button = qa.querySelector('.product-qa-more');

    if (button) {
      button.addEventListener('click', e => {
        e.preventDefault();

        button.remove();

        qa.querySelectorAll('.product-qa-item-more').forEach(item => {
          item.classList.remove('product-qa-item-more');
        });
      });
    }

    qa.classList.add('initialized');
  });
});